import React, { useEffect, useRef, useState } from "react";
import { animate, motion, useInView, useScroll, useTransform } from "framer-motion";
import { useLang } from "../Utility/Languagecontext";
import { ABOUT_IMGS } from "../Utility/Media";
import { SmartImg } from "../Utility/Smartimg";

const EASE = [0.76, 0, 0.24, 1];

// السطر بيطلع من ورا القناع. المراقبة بتتم على العنوان الأب (مش المقصوص)
// عشان المتصفح يعتبره ظاهر ويبدأ الأنيميشن، وبيتعاد كل ما ترجعله.
const MaskLine = ({ children, delay = 0, show }) => (
  <span className="mask">
    <motion.span
      className="mask__inner"
      initial={false}
      animate={{ y: show ? 0 : "115%" }}
      transition={{ duration: 1.1, delay: show ? delay : 0, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

// كل كلمة بتنور مع السكرول (وبتطفي لو رجعت لفوق)
const Word = ({ children, progress, range }) => {
  const opacity = useTransform(progress, range, [0.16, 1]);
  return (
    <motion.span className="word" style={{ opacity }}>
      {children}
    </motion.span>
  );
};

const Counter = ({ to, suffix }) => {
  const { locale } = useLang();
  const ref = useRef(null);
  const inView = useInView(ref, { amount: 0.8 });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) {
      setVal(0);
      return;
    }
    const c = animate(0, to, { duration: 2.2, ease: "easeOut", onUpdate: (v) => setVal(Math.round(v)) });
    return () => c.stop();
  }, [inView, to]);

  return (
    <span ref={ref}>
      {val.toLocaleString(locale)}
      {suffix}
    </span>
  );
};

export const Aboutus = () => {
  const { t } = useLang();
  const sectionRef = useRef(null);
  const leadRef = useRef(null);
  const titleRef = useRef(null);
  const visualRef = useRef(null);

  const titleIn = useInView(titleRef, { amount: 0.3 });
  const visualIn = useInView(visualRef, { amount: 0.12 });

  const { scrollYProgress } = useScroll({ target: sectionRef, offset: ["start end", "end start"] });
  const { scrollYProgress: leadProgress } = useScroll({
    target: leadRef,
    offset: ["start 0.85", "end 0.5"],
  });

  const mainImgY = useTransform(scrollYProgress, [0, 1], ["-7%", "7%"]);
  const frameY = useTransform(scrollYProgress, [0, 1], [70, -70]);
  const smallY = useTransform(scrollYProgress, [0, 1], [150, -150]);
  const thirdY = useTransform(scrollYProgress, [0, 1], [-60, 90]);

  const words = t.about.lead.split(" ");

  return (
    <section className="about" id="about" ref={sectionRef}>
      {/* العنوان بيمتد على العرض كله وبيتداخل فوق صورة القوس */}
      <div className="about__head">
        <motion.p
          className="about__label"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: false, amount: 0.8 }}
          transition={{ duration: 0.9 }}
        >
          {t.about.label}
        </motion.p>

        <h2 className="about__title" ref={titleRef}>
          {t.about.title.map((line, i) => (
            <MaskLine key={line} delay={i * 0.14} show={titleIn}>
              {line}
            </MaskLine>
          ))}
        </h2>
      </div>

      <div className="about__grid">
        <div className="about__text">
          <p className="about__lead" ref={leadRef}>
            {words.map((w, i) => (
              <React.Fragment key={`${w}-${i}`}>
                <Word progress={leadProgress} range={[i / words.length, (i + 1) / words.length]}>
                  {w}
                </Word>{" "}
              </React.Fragment>
            ))}
          </p>

          <motion.p
            className="about__body"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.4 }}
            transition={{ duration: 1 }}
          >
            {t.about.body}
          </motion.p>

          <div className="about__stats">
            {t.about.stats.map((s) => (
              <div className="stat" key={s.label}>
                <div className="stat__num">
                  <Counter to={s.value} suffix={s.suffix} />
                </div>
                <div className="stat__label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="about__visual" ref={visualRef}>
          <motion.div className="about__frame" style={{ y: frameY }} />

          <div className={`about__arch ${visualIn ? "is-in" : ""}`}>
            <SmartImg sources={ABOUT_IMGS.main} style={{ y: mainImgY }} />
          </div>

          <motion.div className="about__small" style={{ y: smallY }}>
            <SmartImg sources={ABOUT_IMGS.second} />
          </motion.div>

          <motion.div className="about__third" style={{ y: thirdY }}>
            <SmartImg sources={ABOUT_IMGS.third} />
          </motion.div>

          <svg className="badge" viewBox="0 0 200 200" aria-hidden="true">
            <defs>
              <path id="badge-circle" d="M100,100 m-78,0 a78,78 0 1,1 156,0 a78,78 0 1,1 -156,0" />
            </defs>
            <text>
              <textPath href="#badge-circle" textLength="486" lengthAdjust="spacing">
                OFF-PLAN • DUBAI • LUXURY • HELMAX •
              </textPath>
            </text>
          </svg>
        </div>
      </div>
    </section>
  );
};